/** Marca do escritório (logos, ícone da aba) — Configurações › Aparência. */
import { useQuery } from "@tanstack/react-query";
import { api } from "./api";

/** Aparência da tela de login. */
export interface LoginLook {
  bg2?: string | null; bgMode?: "cor" | "imagem" | "mosaico" | "dividida"; tileSize?: number; tileGap?: number; tileOpacity?: number; tilePattern?: "alinhado" | "intercalado"; splitSide?: "esquerda" | "direita"; bgFit?: "cobrir" | "inteira"; bgOverlay?: number; card?: string | null; text?: string | null; button?: string | null; buttonText?: string | null;
  bgLogo?: "nenhuma" | "acima" | "lado"; bgLogoSize?: number; cardLogo?: boolean; cardLogoSize?: number; showName?: boolean;
}

export interface Brand {
  logoLight?: string | null; logoDark?: string | null; favicon?: string | null; icon192?: string | null; icon512?: string | null;
  reportJpeg?: string | null; loginBg?: string | null; loginText?: string | null; loginLogo?: string | null; loginBgImage?: string | null;
  login?: LoginLook | null;
  footer?: { address?: string | null; phone?: string | null; email?: string | null; site?: string | null } | null;
  units?: Record<string, { logoLight?: string | null; logoDark?: string | null; icon?: string | null }>;
}

export function useBrand() {
  return useQuery({ queryKey: ["marca"], queryFn: () => api.get<Brand>("/config/marca"), staleTime: 300_000 });
}

/** Logo para um fundo (escuro → versão clara), considerando a logo própria da unidade. */
export function pickLogo(b: Brand | undefined, unitId: string | null | undefined, darkBg: boolean): string | null {
  const u = unitId ? b?.units?.[unitId] : undefined;
  const order = darkBg ? [u?.logoLight, u?.logoDark, b?.logoLight, b?.logoDark] : [u?.logoDark, u?.logoLight, b?.logoDark, b?.logoLight];
  return order.find((x) => !!x) ?? null;
}

/** Ícone quadrado do menu (no lugar da balança): o da unidade, senão o do escritório. */
export function pickIcon(b: Brand | undefined, unitId: string | null | undefined): string | null {
  return (unitId ? b?.units?.[unitId]?.icon : null) || b?.icon192 || b?.favicon || null;
}

/** Ícone da aba do navegador. */
export function setFavicon(href: string | null | undefined): void {
  let link = document.querySelector<HTMLLinkElement>("link[rel='icon']");
  if (!link) { link = document.createElement("link"); link.rel = "icon"; document.head.appendChild(link); }
  const target = href || "/favicon.svg";
  if (link.href !== target) { link.type = href ? "image/png" : "image/svg+xml"; link.href = target; }
}
